var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sort-select"},[_c('simple-select',{attrs:{"selectValues":_vm.values,"name":'videolist-sort-select',"id":'videolist-sort-select',"defaultKeyValue":_vm.defaultKeyValueC},on:{"select":_vm.onSelect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }